import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";

import { useCart } from "../context/CartContext";
import { useLocation } from "../context/LocationContext";
import { useToast } from "../hooks/use-toast";

import apiService from "../services/api";

import HeroSection from "@/components/ui/Homepage/Herosection";
import MainProducts from "@/components/ui/Homepage/MainProducts";
import StoresInfo from "@/components/ui/Homepage/StoresInfo/StoresInfo";
import Testimonial from "@/components/ui/Homepage/Testimonial/Testimonial";
import BakeloreIntro from "@/components/ui/Homepage/BakeloreIntro/BakeloreIntro";
import AboutSection from "@/components/ui/Homepage/AboutSection/AboutSection";
import FloatingOrderButton from "@/components/ui/Homepage/FloatingOrderButton/FloatingOrderButton";
import InstagramFeed from "@/components/ui/Homepage/InstagramFeed";
import TrendingProducts from "@/components/ui/Homepage/TrendingProducts";

const Home = () => {

  const [trendingProducts, setTrendingProducts] = useState([]);
  const [festivalProducts, setFestivalProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);

  const { addToCart } = useCart();
  const { selectedLocation } = useLocation();
  const { toast } = useToast();


  const slidesData = [
  {
    desktop: "https://bakelore.com/images/Mango-Cakes-Online-Hyderabad.webp",
    mobile: "https://bakelore.com/images/Fresh-Mango-Cream-Cake-Hyderabad.webp",
  },

  {
    desktop: "https://bakelore.com/images/Mango-Desserts-Cake-Hyderabad.webp",
    mobile: "https://bakelore.com/images/Premium-Mango-Desserts-Hyderabad.webp",
  },
];


  useEffect(() => {

    if (selectedLocation) {
      loadHomeData();
    }

  }, [selectedLocation]);


  const loadHomeData = async () => {

    try {

      setLoading(true);

      const trendingData =
        await apiService.products.getTrending(selectedLocation.id);

      setTrendingProducts(trendingData.slice(0, 5));


      const festivalData =
        await apiService.products.getFestival(selectedLocation.id);

      setFestivalProducts(festivalData.slice(0, 4));


      const categoriesData =
        await apiService.categories.getAll();

      setCategories(categoriesData.slice(0, 6));


      const offersData =
        await apiService.offers.getAll({
          location_id: selectedLocation.id,
          active_only: true,
        });

      setOffers(offersData.slice(0, 3));

    } catch (error) {

      console.error("Home data error:", error);



    } finally {

      setLoading(false);

    }

  };


  const handleAddToCart = (product) => {

    const variantId =
      product.variants?.length > 0
        ? product.variants[0].id
        : null;

    addToCart(product, variantId, 1);

    toast({
      title: "Added to Cart!",
      description: `${product.name} added successfully`,
    });

  };


  return (

    <>

      <Helmet>

        <title>
          #1 Best bakery in Hyderabad | Bakelore Official Website
        </title>

      </Helmet>


      <div className="min-h-screen">

        <HeroSection
          slides={slidesData}
          bannerLink="#"
          autoSlide
          intervalTime={4000}
        />


        <TrendingProducts
          products={trendingProducts}
          loading={loading}
        />


        <div className="w-full bg-[#ffffff] text-center">

          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#C08B89] px-4">

            Our Brand Story in a Nutshell

          </h2>

          <AboutSection />

        </div>


        <StoresInfo />

        <BakeloreIntro />

        <FloatingOrderButton />

        <Testimonial />

        <MainProducts />

        <InstagramFeed />

      </div>

    </>

  );

};

export default Home;